import { useEffect, useState } from 'react';
import '../../Assets/scss/components/compliance-checker.scss';
import "../../Assets/scss/components/copy-widget-script-code.scss";
import { Accordion, Button, Card, Form, InputGroup, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreProptypes } from '../../PropTypes/StoreProptypes';
import { sendIntergationEmailService, CheckStatusIntergationEmailService, EditIntergationEmailService } from '../../Services/AccessibilityCheckerService';
import { useDispatch } from 'react-redux';
import encodeBase64 from '../../Helpers/encodeBase64';
import { LOADING, SET_MESSAGE } from '../../Actions/Types';
import earthIcon from "../../Assets/img/earth.svg";
import { SketchPicker } from 'react-color';

const AccessibilityChecker = () => {
    const [startScan, setStartScan] = useState(false)
    const [isIntergrate, setIsIntergrate] = useState(false)
    const [website, setWebsite] = useState('')
    const [error, setError] = useState("");
    const [isEmailAlreadyExist, setIsEmailAlreadyExist] = useState(false);
    const [copyCodeSuccess, setCopyCodeSuccess] = useState<boolean>(false);
    const accessToken = useSelector((store: StoreProptypes) => store.accessToken);
    const user = useSelector((store: StoreProptypes) => store.user);
    const activeLanguage = useSelector((store: StoreProptypes) => store.activeLanguage);
    const [standard, setStandard] = useState<string>("WCAG 2.0, 2.1 & 2.2")
    const [email, setEmail] = useState(user?.email ?? '')
    const [encodedString, setEncodedString] = useState<string>('')
    const [encodedStringForCopy, setEncodedStringForCopy] = useState<string>('')
    const [isEditEmail, setIsEditEmail] = useState<boolean>(false)
    const [integrationRequestId, setIntegrationRequestId] = useState<string>('')
    const [changeWidgetBackgroundColor, setChangeWidgetBackgroundColor] = useState<string | undefined>(undefined);
    const [changeTitle, setChangeTitle] = useState<string | undefined>(undefined);
    const [changeStyle, setChangeStyle] = useState<string | undefined>(undefined);
    const [activeKey, setActiveKey] = useState<string | null>(null);

    // Selected mode: "color" or "css"
    const [selectedMode, setSelectedMode] = useState<"color" | "css" | null>(null);
    
    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    useEffect(() => {
        const encodeString = `is_white_label=true&is_partner=true&isFromScript=false&pId=${user?.id}&langCode=${activeLanguage?.code || 'en'}&standard=${standard}`
        setEncodedString(encodeBase64(encodeString))
    }, [user, email, standard])
    
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        // Basic URL validation
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([/?].*)?$/i;

        if (!website.trim()) {
        setError("Please enter a website URL.");
        return;
        }

        if (!urlPattern.test(website.trim())) {
        setError("Please enter a valid URL (e.g. https://example.com).");
        return;
        }

        setError(""); // Clear error
        
        // 👉 Continue your scan logic here...
        setStartScan(true)

        dispatch({
            type: LOADING,
            payload: true,
        });
    };

    const handleHideIntergrateModel = () => {
        setIsIntergrate(false)
        if (!isIntergrate) {
            setIsEmailAlreadyExist(true)
        }
    }

    const handleHideScriptCodeModel = () => {
        setIsEmailAlreadyExist(false)
    }

    function buildTokenParams() {
         let params =
            `is_white_label=true` +
            `&is_partner=true` +
            `&pId=${user?.id}` +
            `&isFromScript=true` +
            `&langCode=${activeLanguage?.code || 'en'}`;
        
        const encodedToken = encodeBase64(params);
        const code = `<iframe src="${process.env.REACT_APP_CHECKER_SERVER_URL}/?token=${encodedToken}" width="100%" sandbox="allow-scripts allow-forms allow-downloads allow-popups allow-same-origin" height="800" style="border:none" loading="lazy" allowfullscreen></iframe>`;
        
        return code;
    }
    console.log('changeStyle: ', changeStyle);


    const handleEmailSubmit = () => {
        // Basic URL validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email.trim()) {
            setError("Please enter your email address.");
            return;
        }

        if (!emailPattern.test(email.trim())) {
            setError("Please enter a valid email address.");
            return;
        }

        setError(""); // Clear error

        if (accessToken && email) {
            if (isEditEmail) {
                EditIntergationEmailService(accessToken, email, integrationRequestId, dispatch,setIntegrationRequestId, changeWidgetBackgroundColor, changeTitle, changeStyle);
                setIsIntergrate(false)
                setIsEmailAlreadyExist(true)
                setEncodedStringForCopy(buildTokenParams())
            } else {
                sendIntergationEmailService(accessToken, email, activeLanguage?.code || 'en',dispatch, setIntegrationRequestId, changeWidgetBackgroundColor, changeTitle, changeStyle);
                setIsIntergrate(false)
                setIsEmailAlreadyExist(true)
                setEncodedStringForCopy(buildTokenParams())
            }
        }

    }

    const iframeLoader = () => {
        dispatch({
            type: LOADING,
            payload: false,
        });
    }

    const checkIntergationSctiptStatus = () => {
        if (user?.id) {
            CheckStatusIntergationEmailService(user?.id.toString()).then((d:any) => {
                if (d.status === '0') {
                    setIsIntergrate(false)
                    setIsEmailAlreadyExist(true)
                    setIntegrationRequestId(d?.Data?.id)
                    setEmail(d?.Data?.email)
                    setChangeWidgetBackgroundColor(d.Data?.background_color !== null ? d.Data?.background_color : undefined)
                    setChangeTitle(d.Data?.title !== null ? d.Data?.title : undefined)
                    setChangeStyle(d.Data?.style !== null ? d.Data?.style : undefined)    
                    setActiveKey(d.Data?.style !== null && d.Data?.style !== ''  ? '3' : '2')
                    setSelectedMode(d.Data?.style !== null && d.Data?.style !== '' ? 'css' : 'color')
                    setEncodedStringForCopy(buildTokenParams())
                } else {
                    setIsIntergrate(true)
                    setIsEmailAlreadyExist(false)
                }
            });
        }
    }

    const handleWidgetCopyCode = () => {
        navigator.clipboard.writeText(encodedStringForCopy);
        setCopyCodeSuccess(true);

        // dispatch copy success message
        dispatch({
            type: SET_MESSAGE,
            payload: {
                "toast_message": t('Copied'),
                "toast_type": "success"
            }
        });

        setTimeout(() => {
            setCopyCodeSuccess(false);
        }, 5000)
    }

    const handleEditEmail = () => {
        setIsEditEmail(true)
        setIsIntergrate(true)
        setIsEmailAlreadyExist(false)
    }

    return (
        <>
            {!startScan ? 
                <div className="compliance-checker w-100">
                    <h2>{t('Our free ADA and WCAG compliance checker identifies web accessibility issues')}</h2>
                    <div className='d-flex w-100 gap-2'>
                        <form className="scan-form" onSubmit={handleSubmit}>
                            <div className="input-wrapper">
                            <InputGroup className="input-group-outline">
                                <img src={earthIcon} className='icon-globe' alt="" aria-hidden="true" />
                                <Form.Control
                                    id="website"
                                    type="text"
                                    placeholder={t('enter website URL')}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setWebsite(e.target.value)} 
                                    value={website}
                                    size="lg"
                                    className='border-right'
                                    required
                                />
                            </InputGroup>
                            </div>
                            <div className="select-wrapper">
                            <select onChange={(e) => setStandard(e.target.value)}>
                                <option value="WCAG 2.0, 2.1 & 2.2">WCAG 2.0, 2.1 & 2.2</option>
                                <option value="California Unruh">California Unruh</option>
                                <option value="Ontario AODA">Ontario AODA</option>
                                <option value="UK Equality Act">UK Equality Act</option>
                                <option value="European EN 301 549">European EN 301 549</option>
                                <option value="Israeli Standard 5568">Israeli Standard 5568</option>
                                <option value="Australian DDA">Australian DDA</option>
                                <option value="ADA Title lll">ADA Title lll</option>
                                <option value="ATAG 2.0">ATAG 2.0</option>
                                <option value="Section 508">Section 508</option>
                                <option value="Canada ACA">Canada ACA</option>
                            </select>
                            </div>
                            &nbsp;&nbsp;
                            <button type="submit" className="start-scan-btn">{t('start scan')}</button>
                        </form>
                        <button className="start-scan-btn" onClick={() => checkIntergationSctiptStatus()}>{t('Integrate')}</button>
                    </div>
                    {error && <p style={{ color: "red", marginTop: "6px" }}>{error}</p>}
                </div>
                : 
                <div>
                    <div className="integration-banner mb-4">
                        <p>{t('Integrate checker in your website')}</p>
                        <button className="integrate-btn" onClick={() => checkIntergationSctiptStatus()}>{t('Integrate')}</button>
                    </div>
                    <iframe
                        src={`${process.env.REACT_APP_CHECKER_SERVER_URL}/?website=${website}&token=${encodedString}`}
                        width="100%"
                        id='myIframe'
                        sandbox="allow-scripts allow-forms allow-downloads allow-popups allow-same-origin"
                        height="800"
                        onLoad={iframeLoader}
                        style={{border: "none"}}
                        allowFullScreen>
                    </iframe>
                </div>
            }
            <Modal show={isIntergrate} onHide={() => handleHideIntergrateModel()} size='lg' backdrop="static" centered>
                <Modal.Header closeButton>
                <Modal.Title>{t('Accessibility checker settings')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                    <p className='fw-bold'>Enter the email where you want to receive the leads</p>
                        <InputGroup className="mt-3 input-group-outline">
                            <Form.Control
                                placeholder={`${t("Enter Email")}`}
                                aria-label={`${t("Enter Email")}`}
                                type="text"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)} value={email}
                            />
                        </InputGroup>
                        <p className='mt-3 mb-2 fw-bold'>Enter Title</p>
                         <InputGroup className="input-group-outline">
                            <Form.Control
                                placeholder={`${t("Enter Title")}`}
                                aria-label={`${t("Enter Title")}`}
                                type="text"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setChangeTitle(e.target.value)} value={changeTitle || ''}
                            />
                        </InputGroup>
                        {error && <p style={{ color: "red", marginTop: "6px" }}>{error}</p>}

                        <Accordion activeKey={activeKey} className='mt-4 d-flex flex-column gap-3 checker-accordion' onSelect={(key:any) => {setActiveKey(key)}}>
                            
                            {/* Background Color */}
                            <Accordion.Item eventKey="2">
                                <Accordion.Header className='fw-bold'>{t("Select Background")}</Accordion.Header>
                                <Accordion.Body>
                                    <div>
                                        <b>Checker Background</b>
                                        <div>
                                            Choose a color to update the widget’s background, card area, button color. This option is the quickest way to adjust the widget appearance while keeping it accessible and readable.
                                        </div>
                                    </div>
                                    
                                    <div className='row mt-3'>
                                        <div className='col-12'>
                                            <div className='fw-bold mb-2'>Background Color</div>
                                            <SketchPicker
                                                disableAlpha={true}
                                                color={changeWidgetBackgroundColor}
                                                onChange={(colorObject, e) => {
                                                    setChangeWidgetBackgroundColor(colorObject.hex);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            {/* Custom CSS */}
                            <Accordion.Item eventKey="3">
                                <Accordion.Header className='fw-bold'>{t("Custom CSS Style")}</Accordion.Header>
                                <Accordion.Body>
                                    <div>
                                        <b>Advanced Custom CSS</b>
                                        <div>Add your own CSS rules to fully customize the widget layout, colors, spacing, borders, and typography. Any CSS entered here will override all default styles and replace the background color settings above.</div>
                                    </div>
                                    <Form.Group controlId="style" className="mt-3">
                                        <Form.Label className='fw-bold'>{t("Custom Style")}</Form.Label>
                                        <Form.Control as="textarea" value={changeStyle ?? ''} placeholder={t("Enter Custom Style")}
                                            aria-label={t("Custom Style")} required onChange={(e) => setChangeStyle(e.target.value)} rows={5} />
                                    </Form.Group>
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>
                        <div className='mt-2'>
                            Note: If you apply a custom style, your selected background and text colors are not applied.
                        </div>
                    </Form>
                    
                </Modal.Body>
                <Modal.Footer className='justify-content-start'>
                    <Button variant="primary" onClick={() => handleEmailSubmit()}>
                        {isEditEmail ? 
                            <>
                                {t('Update')}
                            </> 
                        : 
                            <>
                                {t('Submit')}
                            </>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={isEmailAlreadyExist} onHide={() => handleHideScriptCodeModel()} size='lg' backdrop="static" centered>
                <Modal.Header closeButton>
                <Modal.Title>{t('Embed Code')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex w-100 justify-content-end mb-3 gap-1' style={{ cursor: 'pointer' }} onClick={(e) => handleEditEmail()}>
                        <i className="material-symbols-outlined" aria-hidden="true">settings</i> {t('Settings')}
                    </div>
                    <Card className="aioa_dashboard-copy-widget-code tour-scripts">
                        <Card.Body>
                            <div className='aioa_dashboard-widget-code'>
                                <div className='aioa_dashboard-widget-code-copy-btn'>
                                    <Button aria-label={t("Copy widget embed code").toString()} className='mb-0' variant={`${copyCodeSuccess ? 'success' : 'info'}`} onClick={handleWidgetCopyCode}><i className={`material-symbols-outlined`} aria-hidden="true">{copyCodeSuccess ? 'done' : 'content_copy'}</i></Button>
                                </div>
                                <pre>{encodedStringForCopy}</pre>
                            </div>
                            <div className='mt-3'>
                                You can copy the script to your website and embed our iframe directly into it.
                            </div>
                            
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )

}

export default AccessibilityChecker;